import { useEffect, useState } from 'react';
import axios from 'axios';

// Choix de la session (promo) utilisée pour pré-remplir et redessiner les visuels du jury plénier
export const ChoixSession = ({ valeur, onChange }) => {
  const [sessions, setSessions] = useState([]);
  useEffect(() => {
    axios.get('/presentation-centre/jury-plenier/sessions').then(({ data }) => {
      setSessions(data || []);
      if (!valeur && data?.length) onChange(data[0].session);
    }).catch(() => setSessions([]));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <label className="inline-flex items-center gap-2 rounded-full border border-white/25 px-3 py-1.5 text-sm">
      <span className="text-white/70">Session</span>
      <select value={valeur} onChange={(e) => onChange(e.target.value)} data-testid="presentation-session"
        className="cursor-pointer bg-transparent font-semibold text-white outline-none [&>option]:text-[#0F172A]">
        {!sessions.length && <option value="">aucune</option>}
        {sessions.map((s) => <option key={s.session} value={s.session}>{s.session} ({s.stagiaires} stagiaire{s.stagiaires > 1 ? 's' : ''})</option>)}
      </select>
    </label>
  );
};
